import {
  RemoteData,
  remoteDataNotFetched,
  remoteDataError,
  remoteDataLoading,
  remoteDataOK,
} from '@common/util-models';
import { createReducer, on } from '@ngrx/store';
import { IMEIValidateAPIResultItem } from '@sky/util-models';
import * as ImeiActions from './imei.actions';

export const IMEI_FEATURE_KEY = 'imei';

export interface ImeiState {
  imeiApiResult: IMEIValidateAPIResultItem | undefined;
  remoteState: RemoteData<null>;
}

export interface ImeiPartialState {
  [IMEI_FEATURE_KEY]: ImeiState;
}

export const initialState: ImeiState = {
  imeiApiResult: undefined,
  remoteState: remoteDataNotFetched(),
};

export const imeiReducer = createReducer(
  initialState,
  on(ImeiActions.loadImei, (state) => ({
    ...state,
    imeiApiResult: undefined,
    remoteState: remoteDataLoading(),
  })),

  on(ImeiActions.loadImeiSuccess, (state, { imeiApiResult }) => ({
    ...state,
    imeiApiResult,
    remoteState: remoteDataOK(null),
  })),

  on(ImeiActions.loadImeiFailure, (state, { error }) => ({
    ...state,
    remoteState: remoteDataError(error),
  })),

  on(ImeiActions.resetImei, () => {
    return initialState;
  })
);
